import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext, useMemo } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import ArrowDown from '../../../../Icons/16x16/ArrowDown';
import ArrowUp from '../../../../Icons/16x16/ArrowUp';
import { IconSize } from '../../../../Icons/IconWrap';
import { DropdownStateContext } from '../../../DropdownStateManager';
import noop from 'lodash/noop';
import NativeDropdown from '../../../NativeDropdown';
import s from './SelectFieldContent.scss';
function isPlaceholderValue(value) {
    return value === undefined || value === '';
}
const SelectFieldContent = (_param)=>{
    var { items, value, withBlankOption = true, id, placeholder: placeholderProp, allowComplexLabelOnSelected, disabled, prefix, onSelect = noop, hasError } = _param, rest = _object_without_properties(_param, [
        "items",
        "value",
        "withBlankOption",
        "id",
        "placeholder",
        "allowComplexLabelOnSelected",
        "disabled",
        "prefix",
        "onSelect",
        "hasError"
    ]);
    const { t } = useTranslation();
    const { isOpen, setToggleRef } = useContext(DropdownStateContext);
    const selectListId = `${id}-list`;
    const placeholder = placeholderProp !== null && placeholderProp !== void 0 ? placeholderProp : t('common.select');
    const valueLabel = useMemo(()=>{
        const selectedItem = items.find((item)=>`${item.value}` === `${value}`);
        if (!selectedItem) {
            return placeholder;
        }
        if (allowComplexLabelOnSelected) {
            var _selectedItem_complexLabel, _ref;
            return (_ref = (_selectedItem_complexLabel = selectedItem.complexLabel) !== null && _selectedItem_complexLabel !== void 0 ? _selectedItem_complexLabel : selectedItem.label) !== null && _ref !== void 0 ? _ref : placeholder;
        } else {
            var _selectedItem_label;
            return (_selectedItem_label = selectedItem.label) !== null && _selectedItem_label !== void 0 ? _selectedItem_label : placeholder;
        }
    }, [
        items,
        allowComplexLabelOnSelected,
        value,
        placeholder
    ]);
    const options = useMemo(()=>[
            ...withBlankOption ? [
                {
                    label: placeholder,
                    value: ''
                }
            ] : [],
            ...items.map((item)=>_object_spread_props(_object_spread({}, item), {
                    selected: `${item.value}` === `${value}`
                }))
        ], [
        withBlankOption,
        items,
        value,
        placeholder
    ]);
    const Icon = isOpen ? ArrowUp : ArrowDown;
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], isOpen && s['open'], hasError && s['error'], disabled && s['disabled'])
    }, /*#__PURE__*/ React.createElement("div", {
        id: id,
        tabIndex: 0,
        className: c(s['toggle'], 'ignore-react-onclickoutside'),
        ref: setToggleRef,
        role: "menu",
        "aria-controls": selectListId
    }, prefix && /*#__PURE__*/ React.createElement("div", {
        className: s['prefix']
    }, prefix), !isPlaceholderValue(value) && /*#__PURE__*/ React.createElement("div", {
        className: s['value']
    }, valueLabel), isPlaceholderValue(value) && placeholder && /*#__PURE__*/ React.createElement("div", {
        className: s['placeholder']
    }, placeholder), /*#__PURE__*/ React.createElement(Icon, {
        className: s['icon'],
        size: IconSize.SMALLER,
        disableDefaultColors: true
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['native-dropdown-hidden']
    }, /*#__PURE__*/ React.createElement(NativeDropdown, _object_spread({
        items: options,
        placeholder: placeholder,
        onSelect: onSelect
    }, rest))));
};
SelectFieldContent.displayName = 'SelectFieldContent';
export default SelectFieldContent;

//# sourceMappingURL=SelectFieldContent.js.map